import keys from 'lodash/keys';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
//import get from 'lodash/get';
//import cn from 'classnames';
// import css from './css.css';
import ellipsize from 'ellipsize';
import { Text } from "~/native-ui"
import { Tooltip } from '../../native-ui';


let propTypes = {
    value: PropTypes.string,
    maxLength: PropTypes.number.isRequired,
    children: PropTypes.node,
};
let ownPropNames = keys(propTypes);

export default class CollapseText extends Component {
	static propTypes = propTypes;

	static defaultProps = {
        maxLength: 100,
		tooltip: ""
	};

	state = {
        expanded: false
	};

    ownProps = () => {
        return omit(this.props, ownPropNames);
    };

	render() {
		let { value, maxLength } = this.props;

        let cuttedValue = ellipsize(value, maxLength);

        if(cuttedValue.length !== value.length) {
        	return <Tooltip tooltip={value}><Text {...this.ownProps()}>{cuttedValue}</Text></Tooltip>;
		}

		return <Text {...this.ownProps()}>{value}</Text>;
	}
}